import script from "./ElevateSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ElevateSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ElevateSidebar.vue?vue&type=style&index=0&id=14abfbd3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14abfbd3"]])

export default __exports__